import { server } from 'common/services/server/server';
import getFbData from './getFbData';

interface UserData {
  socialParameters: Record<string, string | undefined>;
}

let cookieReadCount = 0;
const saveFbGoogleData = (id: string, queryParams: URLSearchParams): void => {
  const { fbp, fbc } = getFbData();
  cookieReadCount += 1;

  const gclid = queryParams?.get('gclid');

  const userData: UserData = {
    socialParameters: {},
  };

  if (fbp) {
    userData.socialParameters.fbp = fbp;
  }

  if (fbc) {
    userData.socialParameters.fbc = fbc;
  }

  if (gclid) {
    userData.socialParameters.gclid = gclid;
  }

  if ((fbp || fbc || gclid) && id) {
    server.updateUserById(id, userData);
  } else if (cookieReadCount < 2) {
    setTimeout(saveFbGoogleData, 2000, id);
  }
};

export default saveFbGoogleData;
